// ProfileLivestream.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';

import {
  InfiniteScroller,
  ScrollItem,
} from '../component/InfiniteScroller.jsx';
import Loading from '../component/Loading.jsx';

import ProfileLivestreamItem from '../container/ProfileLivestreamItem.js';

import trackMixpanel, {
  EventTypes,
  getViewId,
  ButtonId,
} from '../resource/mixpanel.js';

import { color, textColor } from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';

import CreatorEmptyLivestreamIconSrouce from '../../img/img_empty_nolivestream_creator.svg';

export const ProfileLivestream = ({
  meId,
  nextPage,
  isNextPageFetching,
  isFirstPageFetched,
  livestreamSessionIds,
  openUploadMenuModal,
  fetchMeLivestreams,
  t,
}) => {
  useEffect(() => {
    fetchMeLivestreams({
      page: 1,
    });
  }, [meId, fetchMeLivestreams]);
  const isEmpty = isFirstPageFetched && !livestreamSessionIds.length;
  if (isEmpty) {
    return (
      <StyledProfileTabLivestream>
        <EmptyWrapper>
          <EmptyIcon src={CreatorEmptyLivestreamIconSrouce} />
          <EmptyActionButton
            onClick={() => {
              trackMixpanel({
                type: EventTypes.USER_CLICKED,
                payload: {
                  viewId: getViewId({
                    pathname: window.location.pathname,
                  }),
                  buttonId: ButtonId.Profile.ButtonCreateLive,
                },
              });
              return openUploadMenuModal();
            }}
          >
            {t('create_live_to_earn')}
          </EmptyActionButton>
        </EmptyWrapper>
      </StyledProfileTabLivestream>
    );
  }
  return (
    <StyledProfileTabLivestream>
      <InfiniteScroller
        pageStart={1}
        useWindow
        threshold={100}
        hasMore={nextPage != null}
        isFetching={isNextPageFetching}
        loadMore={() => fetchMeLivestreams({ page: nextPage })}
      >
        <List>
          <ScrollItem
            loader={
              <LoadingWrapper>
                <Loading />
              </LoadingWrapper>
            }
          >
            {livestreamSessionIds.map(sessionId => {
              return (
                <ProfileLivestreamItem key={sessionId} sessionId={sessionId} />
              );
            })}
          </ScrollItem>
        </List>
      </InfiniteScroller>
    </StyledProfileTabLivestream>
  );
};

ProfileLivestream.propTypes = {
  meId: PropTypes.string,
  nextPage: PropTypes.number,
  isNextPageFetching: PropTypes.bool,
  isFirstPageFetched: PropTypes.bool,
  livestreamSessionIds: PropTypes.array,
  openUploadMenuModal: PropTypes.func,
  fetchMeLivestreams: PropTypes.func,
  t: PropTypes.func.isRequired,
};

ProfileLivestream.defaultProps = {
  meId: null,
  nextPage: null,
  isNextPageFetching: false,
  isFirstPageFetched: false,
  livestreamSessionIds: [],
  openUploadMenuModal: () => null,
  fetchMeLivestreams: () => null,
};

const StyledProfileTabLivestream = styled.div`
  margin-top: 6px;
  padding: 0px 16px;
`;

const List = styled.div``;

const LoadingWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const EmptyWrapper = styled.div`
  margin-top: 40px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 14px;
  color: ${textColor.black};
`;

const EmptyIcon = styled.img`
  margin-bottom: 12px;
  width: 120px;
  height: 120px;
  object-fit: contain;
`;

const EmptyActionButton = styled.button`
  ${ResetButtonStyle};
  border: 1px solid ${color.yellow};
  border-radius: 4px;
  padding: 0px 12px;
  height: 36px;
  font-size: 14px;
  color: ${color.yellow};
`;

export default withTranslation()(ProfileLivestream);
